import CommandsHandler from './commandsHandler';

const handleCommands = ({ response, ...params }) => {
  if (!response || !Array.isArray(response.commands)) return;

  CommandsHandler.handle({
    commands: response.commands,
    ...params
  });
};

const apply = async params => {
  const { request, loaderParams, ...restParams } = params;

  try {
    const response = await request();

    handleCommands({
      response,
      ...restParams
    });

    return response;
  } catch (err) {
    throw new Error(err);
  }
};

const CommandsActions = {
  apply
};

export default CommandsActions;



// WEBPACK FOOTER //
// ./src/store/forms/commands/commandsActions.js